export default "__VITE_ASSET__BxK4VeCf__"